import { ecosystemHelper } from '@/main';
import SideActionBase from '@/plugin/sideActions/sideActionBase';
import { profileModule } from '@/store/modules/profile';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

@Component({
    components: {
        vueDropzone: vue2Dropzone,
    },
})
export default class PurchaseUploadXMLActionComponent extends SideActionBase<any> {
    public getDropZoneOptions() {
        return {
            url: `${Vue.$env().purchasesApiEndpoint}convert/ubl`,
            thumbnailWidth: 150,
            maxFilesize: 10,
            uploadMultiple: false,
            headers: {
                'x-ecosystem': ecosystemHelper.currentEcosystem.id,
                'Authorization': `Bearer ${profileModule.access_token}`,
            },
            paramName: 'file',
        };
    }

    public uploadDone(_, b) {
        this.finished(b);
    }
}
